const getStringSha256Hash = text => {
    if (Array.prototype.reduce) {
        return text.split("").reduce(function (a, b) {
            a = ((a << 5) - a) + b.charCodeAt(0);
            return a & a
        }, 0);
    }
    let hash = 0;
    if (text.length === 0) return hash;
    for (let i = 0; i < text.length; i++) {
        const character = text.charCodeAt(i);
        hash = ((hash << 5) - hash) + character;
        hash = hash & hash;
    }
    return hash;
};

export default getStringSha256Hash;



// WEBPACK FOOTER //
// ./Private/Scripts/helpers/getStringSha256Hash.js